import useLocation from 'react-use/lib/useLocation';
import { IDV_PAGE, NBN_PAGE, SUPPORT_PAGE } from './constants';

const ALLOWED_PATH_PREFIXES_WITH_NBN = [SUPPORT_PAGE, IDV_PAGE, NBN_PAGE];

const pathAllowsNewChat = (path: string = '', allowedPathPrefixes: string[]): boolean => {
  return allowedPathPrefixes.some(prefix => path.startsWith(prefix));
};

export const useCanStartChat = (): boolean => {
  const { pathname } = useLocation();

  return pathAllowsNewChat(pathname, ALLOWED_PATH_PREFIXES_WITH_NBN);
};
